var _defs, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertCircleFillYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fill_alert-circle-fill_copy",
    "data-name": "fill/alert-circle-fill copy",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20Zm0-7a1,1,0,1,0,1,1A1,1,0,0,0,10,13Zm0-8A1,1,0,0,0,9,6v5a1,1,0,1,0,2,0V6A1,1,0,0,0,10,5Z",
    fill: "#ffab05"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(2 2)",
    fill: "#0c3058"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor-2",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20Zm0-7a1,1,0,1,0,1,1A1,1,0,0,0,10,13Zm0-8A1,1,0,0,0,9,6v5a1,1,0,0,0,2,0V6A1,1,0,0,0,10,5Z",
    transform: "translate(0 0)",
    fill: "#ffab05"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircleFillYellow);
export default __webpack_public_path__ + "static/media/alert-circle-fill-yellow.2541703fbec6314c933323882f6f3cb6.svg";
export { ForwardRef as ReactComponent };